<div *ngIf="account$ | async; else login">
  <button class="matero-toolbar-button matero-avatar-button" mat-button [matMenuTriggerFor]="menu">
    <mat-icon class="matero-avatar">account_circle</mat-icon>
    <span class="matero-username" fxHide.lt-sm>
      {{ (account$ | async)?.idTokenClaims?.given_name }}
      {{ (account$ | async)?.idTokenClaims?.family_name }}
    </span>
  </button>
  <mat-menu #menu="matMenu">
    <button routerLink="info/profile" mat-menu-item>
      <mat-icon>person</mat-icon>{{ 'menu.profile' | translate }}
    </button>
    <button (click)="SwitchTheme()" mat-menu-item>
      <mat-icon>dialpad</mat-icon>
      <span *ngIf="settingsService.isDarkTheme()">LightMode</span>
      <span *ngIf="!settingsService.isDarkTheme()">DarkMode</span>
    </button>
    <button (click)="OnLogoutClick()" mat-menu-item>
      <mat-icon>logout</mat-icon>
      <span>Logout</span>
    </button>
  </mat-menu>
</div>

<ng-template #login>
  <button class="matero-toolbar-button" (click)="OnLoginClick()" mat-button>Login</button>
</ng-template>
